import React, { useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Shop from "components/shop/Shop";
import AmazingSuggest from "../components/shop/AmazingSuggest.jsx";
import PopStores from "../components/shop/PopStores.jsx";
import PopularProducts from "../components/shop/PopularProducts.jsx";

import "../components/shop/shop.scss";

import { connection } from "../utils/apiConnection.ts";
import SupplierContext from "context/SupplierContext";
import SingleProduct from "../components/supplier/SingleProduct.jsx";
import Contact from "../components/supplier/Contact.jsx";
import Formatter from "hoc/Formatter";
import { AmazingSuggestion } from "../components/supplier/SinglePartition.jsx";
import { CategoryItem } from "../components/fastOrdering/Category.jsx";
import EditProductModal from "../components/supplier/EditProductModal.jsx";
import Caption from "../components/landing/Caption.jsx";
import shop1 from "../assets/images/shop/shop1.png";
import shops from "../assets/images/shop/shops.png";
import sale from "../assets/images/shop/sale-tag.png";
import Tradesman from "../components/landing/Tradesman.jsx";
import Loader from "utils/Loader";

const ShopPage = (updater) => {
  const { sheep, calf, chicken, fish, shrimp } = useContext(SupplierContext);
  const [popCompany, setPopCompany] = useState([]);
  const [discounted, setDiscounted] = useState([]);
  const [amazing, setAmazing] = useState([]);
  const [popular, setPopular] = useState([]);
  const [popularStore, setPopularStore] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updater1, setUpdater1] = useState(false);
  console.log(setUpdater1, "setUpdater1");
  useEffect(() => {
    console.log(updater1, "updater1");
    async function loadPage() {
      await connection("api/get_best_supplier").then((data) => {
        setCompanies(data.data);
        console.log("poplular : ", data.data);
      });
      await connection("api/get_products", { is_popular: true }).then(
        (data) => {
          setPopular(data.data);
        }
      );
      await connection("api/get_products", { has_discount: true }).then(
        (data) => {
          setAmazing(data.data);
        }
      );
      setIsLoading(false);
    }
    loadPage();
  }, [updater1]);

  // useEffect(() => {
  //   connection("api/get_products", { has_discount: true }).then((data) => {
  //     setAmazing(data.data);
  //   });
  // }, [updater1]);

  // useEffect(() => {
  //   connection("api/get_best_supplier").then((data) => {
  //     setPopCompany(data.data);
  //     console.log("popcompany : ", data.data);
  //   });
  // }, []);

  return (
    <>
      {isLoading && <Loader />}
      <div className=" shopStyles" style={{}}>
        <Shop />
        <div style={{ padding: "100px 6% 20px" }}>
          {amazing && (
            <div className="">
              <div
                className="d-flex w-100 "
                style={{ backgroundColor: "white", borderRadius: "50px" }}
              >
                <AmazingSuggest
                  data={amazing}
                  updater1={updater1}
                  setUpdater1={setUpdater1}
                />
              </div>
            </div>
          )}
          {/* <Caption
        title="محبوب ترین فروشگاه ها"
        captionColor="#6134FF"
       
      /> */}
          <div style={{ paddingTop: "20px" }}>
            <div className="landing">
              <Formatter header="محبوب ترین فروشگاه ها" color="#6134FF">
                <Tradesman
                  title="محبوب ترین فروشگاه ها"
                  bgcolor="#EDEFED"
                  logo={shop1}
                  //data={popCompany}
                  type="store"
                  companies={companies}
                  setCompanies={setCompanies}
                />
              </Formatter>
            </div>
          </div>
          {popular && <PopularProducts data={popular} />}
          <PopStores
            title="پر تخفیف ترین فروشگاه ها"
            bgcolor="#F2E2C8"
            logo={shops}
            image={sale}
            data={discounted}
          />
          {ReactDOM.createPortal(
            <>
              <SingleProduct updater1={updater1} setUpdater1={setUpdater1} />
              <Contact />
              {/* <EditProductModal updater1={updater1} setUpdater1={setUpdater1} /> */}
            </>,
            document.getElementById("modals")
          )}{" "}
        </div>
      </div>
    </>
  );
};

export default ShopPage;
